<xena-dropdown (xnShow)="loadSnippets()">
  <xena-icon name="fas-bolt" slot="trigger" (mouseenter)="loadSnippets()"></xena-icon>
  <xena-menu>
    <xena-menu-item *ngFor="let snippet of snippets" (click)="setSnippet(snippet)">{{formatSnippetContent(snippet.content)}}</xena-menu-item>
    <xena-menu-item disabled *ngIf="!snippets.length && !showIsLoading" i18n="@@snippetNoAvailableSnippets">No available snippets</xena-menu-item>
    <xena-menu-item disabled *ngIf="showIsLoading"><xena-spinner></xena-spinner></xena-menu-item>
    <xena-menu-divider></xena-menu-divider>
    <xena-menu-item (click)="openManageSnippets()">
      <xena-icon slot="prefix" name="fas-cog"></xena-icon>
      <span i18n="@@snippetManageSnippets">Manage snippets</span>
    </xena-menu-item>
  </xena-menu>
</xena-dropdown>
